import { TooltipData } from "types";
import { Help } from "components/Help";

export const getSymbols = ({ tooltips, roadClass, t }: { tooltips?: TooltipData | null; roadClass?: string; t: (key: string) => string }) => ({
  Lav: <strong>L̄m</strong>,
  Uo: (
    <strong>
      <span>
        U<sub>o</sub>
      </span>
    </strong>
  ),
  UoE: (
    <strong>
      <span>
        U<sub>o</sub> (E)
      </span>
    </strong>
  ),
  Ul: (
    <strong>
      <span>
        U<sub>l</sub>
      </span>
    </strong>
  ),
  fTI: (
    <strong>
      <span>
        f<sub>TI</sub>
      </span>
      {!roadClass?.includes("m") && <Help size="small" text={tooltips?.road_classes_fti ?? t("Informative, not normative")} />}
    </strong>
  ),
  Rei: (
    <strong>
      <span>
        R<sub>EI</sub>
      </span>
      <Help size="small" text={tooltips?.road_classes_rei ?? t("Rei has just to be calculated if a adjacent-area at one or both sides is missing.")} />
    </strong>
  ),
  Eav: <strong>Ēm</strong>,
  Emin: (
    <strong>
      <span>
        E<sub>min</sub>
      </span>
    </strong>
  ),
  Evmin: (
    <strong>
      <span>
        E<sub>v,min</sub>
      </span>
      <Help
        size="small"
        text={
          tooltips?.road_classes_evmin ?? t("These values are not calculated. If you need to apply these, please ask your local Signify representative for help.")
        }
      />
    </strong>
  ),
  Escmin: (
    <strong>
      <span>
        E<sub>sc,min</sub>
      </span>
      <Help
        size="small"
        text={
          tooltips?.road_classes_escmin ?? "These values are not calculated. If you need to apply these, please ask your local Signify representative for help."
        }
      />
    </strong>
  ),
});
